export default "__VITE_ASSET__g9jfqYc0__"